import { render, staticRenderFns } from "./PageEntity.vue?vue&type=template&id=3b24a0ca&scoped=true"
import script from "./PageEntity.vue?vue&type=script&lang=js"
export * from "./PageEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24a0ca",
  null
  
)

export default component.exports